import { cloneDeep as e } from "../../../../../utils/cloneDeep.js";
import { ENGLISH_MONTHS as t, weeks as n } from "../../calendar-engine/constants/calendar-date.js";
import { clearEndDateIfBeforeStart as r } from "../../utilities/index.js";
import { Pipeline as i } from "../../utilities/pipeline.js";
import { ErrorMessage as a, today as o } from "../config/index.js";
import { getStrategy as s } from "../libs/strategy/strategy-provider.js";
import { ModeEnum as c, ViewModeEnum as l } from "./model.js";
import u from "dayjs";
import { createStore as d } from "zustand";
// src/design/forms/datepicker/core/models/store.ts
var f = {
	mode: c.RANGE,
	startDate: "",
	endDate: "",
	isNepali: !1,
	showToggle: !0,
	closeOnSelect: !0,
	showSecondaryDate: !1,
	disableDateBefore: "",
	disableDateAfter: "",
	disabledWeekDays: [],
	holidays: [],
	isDisabled: !1,
	onChange: () => {},
	onError: () => {}
}, p = {
	startDateRef: { current: null },
	endDateRef: { current: null },
	currentDateSelection: "startDate",
	isOpen: !1,
	animationDirection: "right",
	calendarReferenceDate: u().format("YYYY-MM-DD"),
	gridDatesWithMeta: {
		gridDates: [],
		primaryYear: 0,
		primaryMonth: "",
		secondaryYear: 0,
		secondaryMonthCombination: ""
	},
	yearGridDatesWithMeta: [],
	yearGridDates: [],
	viewMode: l.CALENDAR_VIEW,
	monthYearPanelData: "",
	gridYears: [],
	error: "",
	gridMonths: t,
	isTodayValid: !1,
	weeks: n.en,
	controllerLabel: {
		month: "",
		year: ""
	}
}, m = (t, n) => ({
	syncProps: (r) => {
		let a = e(t().ctx), o = s(a.isNepali);
		r.isDisabled !== void 0 && (a.isDisabled = r.isDisabled), r.disabledWeekDays !== void 0 && (a.disabledWeekDays = r.disabledWeekDays), r.showToggle !== void 0 && (a.showToggle = r.showToggle), r.closeOnSelect !== void 0 && (a.closeOnSelect = r.closeOnSelect), r.showSecondaryDate !== void 0 && (a.showSecondaryDate = r.showSecondaryDate), r.holidays !== void 0 && (a.holidays = r.holidays);
		let c = i();
		c.push(o.setConvertedDate({
			startDate: r.startDate,
			endDate: r.endDate
		})), c.push(o.setCalendarReferenceDate(!1)), c.push(o.setDisableDateBefore(r.disableDateBefore || "")), c.push(o.setDisableDateAfter(r.disableDateAfter || "")), c.push(o.setGridMonths), c.push(o.setGridDatesWithMeta), c.push(o.setMonthYearPanelData), c.push(_(n)), c.execute({ next: a });
	},
	openCalendar: async (r) => {
		let a = e(t().ctx);
		a.isOpen = !0, a.currentDateSelection = r;
		let l = a.mode === c.RANGE && r === "endDate" && !a.startDate;
		l && (a.currentDateSelection = "startDate"), a.mode === c.WEEK && (a.currentDateSelection = "startDate");
		let u = s(a.isNepali), d = i();
		d.push(u.checkIfDateIsValid), d.push(u.setViewModeToCalendar), d.push(u.setCalendarReferenceDate(!1)), d.push(u.setIsTodayValid(o)), d.push(u.setGridDatesWithMeta), d.push(u.setYearGridDatesWithMeta), d.push(u.setMonthYearPanelData), d.push(u.setCalendarControllerLabels), d.push(_(n)), await d.execute({ next: a }), l && t().ctx.startDateRef.current?.focus();
	},
	selectDate: async (r) => {
		let a = e(t().ctx), o = s(a.isNepali), l = a.mode === c.RANGE && a.currentDateSelection === "startDate", u = i();
		u.push(o.setDate(r)), u.push(g), u.push(o.checkIfStartDateIsBeforeEndDate), u.push(o.setGridDatesWithMeta), l || u.push(o.closeCalendarPicker), u.push(_(n)), u.push(o.sendChanges), await u.execute({ next: a }), l && (t().ctx.endDateRef.current?.focus(), t().events.openCalendar("endDate"));
	},
	initCalendarView: async () => {
		let r = e(t().ctx), a = s(r.isNepali), o = i();
		o.push(a.setGridDatesWithMeta), o.push(_(n)), await o.execute({ next: r });
	},
	clearCalendarView: async () => {
		let r = e(t().ctx);
		r.gridDatesWithMeta = {
			gridDates: [],
			primaryYear: 0,
			primaryMonth: "",
			secondaryYear: 0,
			secondaryMonthCombination: ""
		}, await i().push(_(n)).execute({ next: r });
	},
	initMonthView: async () => {
		let r = e(t().ctx);
		r.isOpen = !0;
		let a = s(r.isNepali);
		await i().push(a.setGridMonths).push(_(n)).execute({ next: r });
	},
	clearMonthView: async () => {
		let r = e(t().ctx);
		r.gridMonths = [], await i().push(_(n)).execute({ next: r });
	},
	closeCalendar: () => {
		let r = e(t().ctx);
		r.isOpen = !1, n({ ctx: r });
	},
	nextMonth: async () => {
		let r = e(t().ctx);
		r.animationDirection = "right", n({ ctx: r });
		let a = s(r.isNepali), o = i();
		o.push(a.incrementMonth), o.push(_(n)), await o.execute({ next: r });
	},
	previousMonth: async () => {
		let r = e(t().ctx);
		r.animationDirection = "left", n({ ctx: r });
		let a = s(r.isNepali), o = i();
		o.push(a.decrementMonth), o.push(_(n)), await o.execute({ next: r });
	},
	nextYear: async () => {
		let r = e(t().ctx), a = s(r.isNepali);
		await i().push(a.incrementYear).push(_(n)).execute({ next: r });
	},
	previousYear: async () => {
		let r = e(t().ctx), a = s(r.isNepali);
		await i().push(a.decrementYear).push(_(n)).execute({ next: r });
	},
	selectWeek: async (r) => {
		let a = e(t().ctx);
		a.currentDateSelection = "startDate";
		let o = s(a.isNepali), c = i();
		c.push(o.setDate(r)), c.push((e, t) => {
			let n = e.next.startDate;
			n && (e.next.startDate = u(n).startOf("week").format("YYYY-MM-DD"), e.next.endDate = u(n).endOf("week").format("YYYY-MM-DD")), t();
		}), c.push(o.checkIfStartDateIsBeforeEndDate), c.push(o.setGridDatesWithMeta), c.push(o.closeCalendarPicker), c.push(_(n)), c.push(o.sendWeekChanges), await c.execute({ next: a });
	},
	selectToday: async () => {
		let r = e(t().ctx), a = s(r.isNepali), l = i();
		l.push(a.checkIfTodayIsValid), l.push(a.setTodayAsDate(o)), l.push(g), l.push(a.setTodayAsCalendarReferenceDate), l.push(a.setGridDatesWithMeta), l.push(a.setMonthYearPanelData), l.push(a.setCalendarControllerLabels), l.push(a.closeCalendarPicker), l.push(_(n)), l.push(a.sendChanges), await l.execute({ next: r }), r = e(t().ctx), r.mode === c.RANGE && r.currentDateSelection === "startDate" && (r.endDateRef.current && r.endDateRef.current.focus(), t().events.openCalendar("endDate"));
	},
	goToMonthView: async () => {
		let r = e(t().ctx), a = s(r.isNepali), o = i();
		o.push(a.setViewModeToMonth), o.push(a.setGridMonths), o.push(_(n)), await o.execute({ next: r });
	},
	goToYearView: async () => {
		let r = e(t().ctx), a = s(r.isNepali), o = i();
		o.push(a.setViewModeToYear), o.push(_(n)), await o.execute({ next: r });
	},
	getNextDecadeYearGrid: async () => {
		let r = e(t().ctx), a = s(r.isNepali), o = i();
		o.push(a.incrementDecade), o.push(_(n)), await o.execute({ next: r });
	},
	getPreviousDecadeYearGrid: async () => {
		let r = e(t().ctx), a = s(r.isNepali), o = i();
		o.push(a.decrementDecade), o.push(_(n)), await o.execute({ next: r });
	},
	setState: (e) => {
		e?.(t, n);
	},
	onDateChange: async (r) => {
		let a = e(t().ctx), o = s(a.isNepali);
		await i().push(o.checkIfDateIsValid).push(o.setDateForTypingEvent(r)).push(o.checkIfStartDateIsBeforeEndDate).push(o.sendChanges).push(o.setCalendarReferenceDate(!0)).push(_(n)).execute({ next: a });
	},
	toggleContext: async (r, a) => {
		let o = e(t().ctx);
		o.isNepali = !o.isNepali;
		let l = s(o.isNepali), u = i();
		r?.(u, l), u.push(_(n)), a?.(u, l), u.push((e, t) => {
			let n = e.next.mode === c.RANGE ? {
				isNepali: e.next.isNepali,
				startDate: e.next.startDate,
				endDate: e.next.endDate
			} : {
				isNepali: e.next.isNepali,
				date: e.next.startDate
			};
			o.onToggleChange && o.onToggleChange(n), t();
		}), await u.execute({ next: o });
	},
	setStartAndEndDate: async (r) => {
		let a = e(t().ctx), o = s(a.isNepali), c = i();
		c.push(o.setStartAndEndDate(r.startDate ?? a.startDate, r.endDate ?? a.endDate)), c.push(o.setGridDatesWithMeta), c.push(_(n)), c.push(o.sendChanges), await c.execute({ next: a });
	}
}), h = (e) => {
	let t = {
		...f,
		...p,
		...e
	};
	return d((e, n) => ({
		ctx: t,
		events: m(n, e)
	}));
}, g = (e, t) => {
	if (e.next.mode === c.RANGE) {
		let t = !!e.next.endDate;
		r(e.next), t && !e.next.endDate && e.next.error === a.START_AND_END_DATE_BOUNDS && (e.next.error = "", e.next.onError?.(""));
	}
	t();
}, _ = (e) => (t, n) => {
	e({ ctx: t.next }), n();
};
export { f as DEFAULT_PROPS, p as INTERNAL_PROPS, _ as commitCtx, h as createMyStore };

//# sourceMappingURL=store.js.map